import { ConsultaDeAcesso } from "./ConsultaDeAcesso";

export default ConsultaDeAcesso;